/*
 * inselvolt Kompatibilitätsberater — Engine (präsentationsfrei).
 *
 * Reine Funktionen über der kuratierten Datenbasis (daten/berater-daten.js).
 * Kein DOM, kein Fetch, kein Tracking, keine Marge-Logik.
 *
 * Harte Invarianten (CLAUDE.md — nie aufweichen):
 *  - Kompatibilität AUSSCHLIESSLICH aus den Freigabe-Einträgen (Whitelist der
 *    Herstellerlisten). Keine Inferenz aus Spannung/Chemie/Hersteller/Modulanzahl.
 *  - Eine Kombination ohne Hersteller-Freigabe-Eintrag ist „auf Anfrage prüfen" —
 *    niemals „inkompatibel", niemals stillschweigend kompatibel.
 *  - Distributor-Quellen (typ 'distributor') BESTÄTIGEN nur; die Freigabe selbst
 *    trägt eine Hersteller-Quelle (typ 'hersteller').
 *  - Fehlende Leistungswerte ⇒ null und ehrliche Kennzeichnung, nie 0 oder Schätzung.
 *  - kombi_entlade_kw = min(WR-Grenzen, Speicher-Entladeleistung, Kombinationsgrenze)
 *    — nur über dokumentierte Werte; unbekannte Glieder werden benannt (begrenzt_durch).
 *    Die Kombinationsgrenze ist optional: Manche Herstellerlisten (Fronius GEN24 Plus)
 *    nennen die zulässige DC-Leistung nicht je Gerät, sondern je Paarung aus WR-Variante
 *    und Speichergröße — kleine Türme erreichen den Gerätewert nicht, weil die
 *    Turmspannung mit der Modulzahl wächst. Wo eine Liste das ausweist, ist dieser
 *    Wert verbindlich; er liegt unter den Einzelgrenzen und wird nie überschritten.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.IVBeraterEngine = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  /*
   * Rangfolge der Hersteller — gilt in JEDEM Auswahl- und Ausgabefeld, auf der
   * Beraterseite wie auf der Produktseite. Deshalb steht sie hier und nicht in
   * einer der beiden Oberflächen: Zwei Listen würden auseinanderlaufen.
   *
   * Rang 0 sind die Marken mit hinterlegtem Logo. Sie stehen zuerst und ohne
   * jeden Zusatz. Rang 1 ist alles Übrige aus den Herstellerfreigaben.
   *
   * Bewusst KEINE Aussage über Lieferbarkeit: Auch aus der zweiten Gruppe ist
   * einiges bei inselvolt erhältlich. Die Rangfolge ordnet die Ansicht, sie
   * behauptet nichts über das Sortiment.
   *
   * Die Liste muss deckungsgleich mit LOGOS in app/berater-ui.js sein — ein
   * Test prüft das, sonst hinge die Reihenfolge an einer stillen Kopie.
   */
  var WESENTLICHE_HERSTELLER = [
    'AlphaESS', 'AXITEC', 'BYD', 'Deye', 'Dyness', 'Felicity', 'Fronius',
    'GoodWe', 'Growatt', 'Huawei', 'KOSTAL', 'Pylontech', 'SMA', 'SolarEdge', 'SolaX', 'Sungrow',
  ];

  var RANG_INDEX = {};
  WESENTLICHE_HERSTELLER.forEach(function (h) { RANG_INDEX[h] = 0; });

  function herstellerRang(name) { return RANG_INDEX[name] === 0 ? 0 : 1; }

  /* Rang zuerst, dann alphabetisch — der Vergleich für alle Herstellerlisten. */
  function vergleicheHersteller(a, b) {
    var ra = herstellerRang(a), rb = herstellerRang(b);
    if (ra !== rb) return ra - rb;
    return String(a).localeCompare(String(b), 'de');
  }

  var PROFILE = {
    standard: { kw: 3, name: 'Standard-Haushalt' },
    wp_oder_wallbox: { kw: 7, name: 'Wärmepumpe oder Wallbox' },
    beides_hohe_last: { kw: 10, name: 'Beides / hohe Last' },
  };

  function istZahl(x) {
    return typeof x === 'number' && isFinite(x);
  }

  /*
   * Spannungsklasse eines Geräts. Hochvolt ist der Normalfall dieser Datenbasis
   * (Hausspeicher mit 100 bis 500 V), Niedervolt die 48-V-Welt. Deshalb muss nur
   * das Abweichende gepflegt werden — ein fehlendes Feld heißt 'hochvolt'.
   * Die beiden Welten sind nicht kombinierbar; sichtbar wird das aber ohnehin
   * über die Freigaben, denn keine Herstellerliste führt sie gemeinsam.
   */
  function spannungsklasse(familie) {
    return familie && familie.spannungsklasse === 'niedervolt' ? 'niedervolt' : 'hochvolt';
  }

  function runde2(n) {
    return Math.round(n * 100) / 100;
  }

  // ---- Index-Zugriffe (rein, ohne Zustand) ----

  function findeWrVariante(daten, varianteId) {
    for (var i = 0; i < daten.wechselrichter.length; i++) {
      var fam = daten.wechselrichter[i];
      for (var j = 0; j < fam.varianten.length; j++) {
        if (fam.varianten[j].id === varianteId) return { familie: fam, variante: fam.varianten[j] };
      }
    }
    return null;
  }

  function findeSpeicher(daten, speicherId) {
    for (var i = 0; i < daten.speicher.length; i++) {
      if (daten.speicher[i].id === speicherId) return daten.speicher[i];
    }
    return null;
  }

  /*
   * Whitelist-Kern: liefert die Quellen-Belege für (WR-Familie, WR-Variante,
   * Speicher-Familie, Größe) — ausschließlich aus daten.freigaben.
   * Leere Liste ⇒ kein Beleg ⇒ „auf Anfrage".
   */
  function belegeFuerKombi(daten, wrFamilieId, wrVarianteId, speicherId, groesse) {
    var belege = [];
    for (var i = 0; i < daten.freigaben.length; i++) {
      var f = daten.freigaben[i];
      if (f.wr !== wrFamilieId) continue;
      if (f.speicher !== speicherId) continue;
      if (f.groessen.indexOf(groesse) === -1) continue;
      if (f.wr_varianten && wrVarianteId && f.wr_varianten.indexOf(wrVarianteId) === -1) continue;
      belege.push(f);
    }
    return belege;
  }

  /*
   * Kombinationsabhängige DC-Grenze aus den Belegen — optional, nur wo eine Liste sie
   * ausweist (`dc_grenzen[<wr_varianten_id>][<groesse>]`, ein Wert für Laden und Entladen).
   * Belegen mehrere Quellen dieselbe Paarung, gilt der niedrigste Wert: Die Freigabe darf
   * nie mehr versprechen, als die vorsichtigste Herstellerangabe deckt.
   * Kein Eintrag ⇒ null ⇒ die Rechnung bleibt exakt wie bisher.
   */
  function kombiGrenzeKw(belege, wrVarianteId, groesse) {
    var treffer = null;
    for (var i = 0; i < belege.length; i++) {
      var tabelle = belege[i].dc_grenzen;
      if (!tabelle || !wrVarianteId) continue;
      var zeile = tabelle[wrVarianteId];
      if (!zeile) continue;
      var kw = zeile[groesse];
      if (!istZahl(kw)) continue;
      if (treffer === null || kw < treffer) treffer = kw;
    }
    return treffer;
  }

  /*
   * Ausdrücklich ausgeschlossene Paarungen — das Gegenstück zur Whitelist, und
   * die EINZIGE Stelle, an der eine Unverträglichkeit behauptet werden darf.
   *
   * Der Unterschied zu „nicht gelistet" ist der ganze Punkt: Eine Größe, die in
   * keiner Liste steht, ist unbelegt (⇒ 'auf_anfrage'). Eine Größe, die eine
   * Herstellerliste ausdrücklich ausnimmt, ist belegt ausgeschlossen — dafür
   * gibt es ein Dokument mit Wortlaut. Das eine dürfen wir nie behaupten, das
   * andere nie verschweigen.
   *
   * Nur `typ: 'hersteller'` schließt aus. Dieselbe Asymmetrie wie bei der
   * Freigabe (Invariante 2): Eine Distributor-Liste bestätigt nur, sie
   * entscheidet nicht — weder dafür noch dagegen.
   *
   * Eine widersprechende Freigabe sticht den Ausschluss (siehe
   * statusFuerKombi). Dieser Fall existiert in der Datenbasis nicht und wird
   * von einem Test gehalten: Träte er auf, ist das ein Datenbefund für einen
   * Menschen, keine Regel, die die Engine still anwenden soll.
   */
  function ausschlussFuerKombi(daten, wrFamilieId, wrVarianteId, speicherId, groesse) {
    for (var i = 0; i < daten.freigaben.length; i++) {
      var f = daten.freigaben[i];
      if (f.wr !== wrFamilieId) continue;
      if (f.speicher !== speicherId) continue;
      if (!f.ausgeschlossen || f.ausgeschlossen.indexOf(groesse) === -1) continue;
      if (f.wr_varianten && wrVarianteId && f.wr_varianten.indexOf(wrVarianteId) === -1) continue;
      var quelle = daten.quellen[f.quelle];
      if (!quelle || quelle.typ !== 'hersteller') continue;
      return f;
    }
    return null;
  }

  /*
   * Status einer Kombination:
   *  'freigegeben'    — mindestens eine Hersteller-Quelle belegt die Freigabe
   *  'ausgeschlossen' — eine Herstellerliste nimmt genau diese Paarung aus
   *  'auf_anfrage'    — kein Beleg in beide Richtungen (ggf. nur Distributor ⇒ Hinweis)
   *
   * Es gibt weiterhin keinen Status „inkompatibel", der aus Spannung, Chemie
   * oder Bauart abgeleitet wäre. 'ausgeschlossen' steht ausschließlich dort,
   * wo ein Hersteller es selbst geschrieben hat.
   */
  function statusFuerKombi(daten, belege, ausschluss) {
    var herstellerBelege = [];
    var distributorBelege = [];
    for (var i = 0; i < belege.length; i++) {
      var quelle = daten.quellen[belege[i].quelle];
      if (quelle && quelle.typ === 'hersteller') herstellerBelege.push(belege[i]);
      else distributorBelege.push(belege[i]);
    }
    if (herstellerBelege.length > 0) {
      return { status: 'freigegeben', hersteller_belege: herstellerBelege, distributor_belege: distributorBelege };
    }
    if (ausschluss) {
      return {
        status: 'ausgeschlossen',
        hersteller_belege: [],
        distributor_belege: distributorBelege,
        ausschluss_quelle: ausschluss.quelle,
        ausschluss_wortlaut: ausschluss.ausschluss_wortlaut || null,
      };
    }
    return { status: 'auf_anfrage', hersteller_belege: [], distributor_belege: distributorBelege };
  }

  /*
   * Speicher-Leistungswerte je Größe: Größen-Eintrag (Datenblatt je Turmgröße)
   * hat Vorrang, Familien-Felder sind Fallback. Fehlt beides ⇒ null.
   */
  /*
   * Leistung einer Speichergröße — und woher sie stammt.
   *
   * Bis 2026-08-16 kam hier nur eine Zahl heraus. Wer sie gerechnet hatte, stand
   * bestenfalls als Prosa in `leistung_herleitung`, die kein Programm liest. Das
   * war der blinde Fleck, an dem die AlphaESS-Reihen hingen: Dort war die
   * Leistung EINES Moduls (52,5 A × 96 V = 5,04 kW) für jede Turmgröße
   * eingetragen — ein 6er-Turm hat aber 576 V und damit rund 30 kW. Eine
   * plausible Zahl, gegen die nichts zu halten war, weil ihre Zutaten nicht in
   * den Daten standen.
   *
   * Jetzt gilt auf der Speicherseite dasselbe wie längst auf der
   * Wechselrichterseite (Invariante 3): Die Zutaten stehen in der Datenbasis,
   * die Rechnung macht die Engine, und das Ergebnis trägt seine Herkunft.
   *
   *   dokumentiert  Wert steht so im Datenblatt
   *   berechnet     Strom × Turmspannung — beides Datenblattangaben, die
   *                 Multiplikation ist unsere. Die UI sagt das dem Kunden.
   *
   * Herstelleraussage schlägt Rechnung: Ein dokumentierter Wert gewinnt immer.
   */
  function speicherSpec(familie, groessenEintrag) {
    var g = groessenEintrag || {};

    function wert(ausGroesse, ausFamilie, gerechnet) {
      if (istZahl(ausGroesse)) return { kw: ausGroesse, herkunft: 'dokumentiert' };
      if (istZahl(ausFamilie)) return { kw: ausFamilie, herkunft: 'dokumentiert' };
      if (istZahl(gerechnet)) return { kw: gerechnet, herkunft: 'berechnet' };
      return { kw: null, herkunft: null };
    }

    var entladen = wert(g.entlade_kw, familie.entlade_leistung_kw,
      speicherGrenzeKw(familie, groessenEintrag, 'entladen'));
    var laden = wert(g.lade_kw, familie.lade_leistung_kw,
      speicherGrenzeKw(familie, groessenEintrag, 'laden'));
    var gerechnet = speicherGrenzeKw(familie, groessenEintrag, 'entladen');
    return {
      entlade_leistung_kw: entladen.kw,
      lade_leistung_kw: laden.kw,
      entlade_herkunft: entladen.herkunft,
      lade_herkunft: laden.herkunft,
      berechnete_speicher_kw: istZahl(gerechnet) ? gerechnet : null,
    };
  }

  /*
   * Strom × Turmspannung auf der Speicherseite — dieselbe Rechnung wie
   * berechneteGrenzeKw auf der Geräteseite, nur mit dem Strom der Batterie.
   * Ohne `strom_a` oder ohne Turmspannung gibt es keinen Wert; geschätzt wird
   * nichts.
   */
  function speicherGrenzeKw(familie, groessenEintrag, richtung) {
    if (!familie) return null;
    /*
     * Manche Blaetter nennen einen Strom fuer beide Richtungen, manche zwei.
     * Die VARTA.wall BM1 etwa fuehrt "Max. Lade-/Entladestrom 22 A / 26 A" —
     * Laden und Entladen sind dort verschieden, und ein gemeinsamer Wert waere
     * in einer Richtung zu hoch und in der anderen zu niedrig.
     */
    var strom = familie.strom_a;
    if (richtung === 'laden' && istZahl(familie.strom_lade_a)) strom = familie.strom_lade_a;
    if (richtung === 'entladen' && istZahl(familie.strom_entlade_a)) strom = familie.strom_entlade_a;
    if (!istZahl(strom)) return null;
    var spannung = turmSpannungV(familie, groessenEintrag);
    if (!istZahl(spannung)) return null;
    return runde2(strom * spannung / 1000);
  }

  /*
   * Kombinierte Lade-/Entladeleistung — nur aus dokumentierten Werten.
   * Rückgabe je Richtung: { kw, begrenzt_durch, unvollstaendig, fehlend }
   *  - kw: min() über alle bekannten Grenzen (null, wenn keine bekannt)
   *  - begrenzt_durch: welches bekannte Glied das Minimum setzt
   *    ('wr' | 'speicher' | 'kombination' | 'berechnet')
   *  - unvollstaendig: true, wenn ein Glied unbekannt ist (dann ist kw eine Obergrenze!)
   *
   * `grenzen` bündelt die beiden paarungsabhängigen Glieder — beide optional:
   *  - dokumentiert: von der Herstellerliste je Paarung ausgewiesen (siehe kombiGrenzeKw)
   *  - berechnet:    Batteriestrom des Geräts × Turmspannung (siehe berechneteGrenzeKw).
   *    Aus zwei Datenblattangaben errechnet, vom Hersteller so NICHT ausgesprochen —
   *    deshalb ein eigenes Etikett, das die UI sichtbar macht.
   * Beide treten als weiteres Glied in dieselbe min()-Rechnung und haben keinen Vorrang;
   * sie gewinnen schlicht, wenn sie niedriger sind. Fällt der dokumentierte Wert mit dem
   * errechneten zusammen, gilt der dokumentierte — Herstelleraussage schlägt Rechnung.
   *
   * Keiner der beiden schließt eine Lücke: Fehlt daneben ein Gerätewert, bleibt die
   * Rechnung unvollständig, denn es sind DC-Werte; beim Entladen kommt AC-seitig noch
   * der Wechselrichter-Wirkungsgrad dazu.
   */
  function kombiLeistung(wrVariante, speicherFamilie, grenzen) {
    var g = grenzen || {};
    var dok = istZahl(g.dokumentiert) ? g.dokumentiert : null;
    var ber = istZahl(g.berechnet) ? g.berechnet : null;
    function richtung(wrGrenzen, speicherKw, speicherHerkunft) {
      var bekannteWr = wrGrenzen.filter(istZahl);
      var glieder = bekannteWr.slice();
      if (istZahl(speicherKw)) glieder.push(speicherKw);
      if (dok !== null) glieder.push(dok);
      if (ber !== null) glieder.push(ber);
      var fehlend = [];
      if (bekannteWr.length === 0) fehlend.push('wr');
      if (!istZahl(speicherKw)) fehlend.push('speicher');
      /* Woher der Speicherwert stammt, wandert unveraendert mit: Die UI muss
       * „errechnet" auch dann sagen koennen, wenn der Speicher die Grenze setzt. */
      var basis = { kombi_grenze_kw: dok, berechnete_grenze_kw: ber, speicher_herkunft: speicherHerkunft || null };
      if (glieder.length === 0) {
        return { kw: null, begrenzt_durch: null, unvollstaendig: true, fehlend: fehlend, kombi_grenze_kw: dok, berechnete_grenze_kw: ber, speicher_herkunft: basis.speicher_herkunft };
      }
      var min = Math.min.apply(null, glieder);
      /*
       * Reihenfolge der Erklärung, nicht der Rechnung: Wo eine paarungsabhängige Grenze
       * das Minimum setzt, ist sie die Auskunft, die dem Kunden weiterhilft ("dieser Turm
       * ist für dieses Gerät zu klein"). Der belegte Wert kommt vor dem errechneten.
       */
      var etikett = null;
      if (dok !== null && dok === min) etikett = 'kombination';
      else if (ber !== null && ber === min) etikett = 'berechnet';
      if (etikett) {
        return { kw: runde2(min), begrenzt_durch: etikett, unvollstaendig: fehlend.length > 0, fehlend: fehlend, kombi_grenze_kw: dok, berechnete_grenze_kw: ber, speicher_herkunft: basis.speicher_herkunft };
      }
      var durchSpeicher = istZahl(speicherKw) && speicherKw === min && (bekannteWr.length === 0 || min <= Math.min.apply(null, bekannteWr));
      return {
        kw: runde2(min),
        begrenzt_durch: durchSpeicher ? 'speicher' : 'wr',
        unvollstaendig: fehlend.length > 0,
        fehlend: fehlend,
        kombi_grenze_kw: basis.kombi_grenze_kw,
        berechnete_grenze_kw: basis.berechnete_grenze_kw,
        speicher_herkunft: basis.speicher_herkunft,
      };
    }
    return {
      entladen: richtung([wrVariante.bat_entlade_kw, wrVariante.ac_kw],
        speicherFamilie.entlade_leistung_kw, speicherFamilie.entlade_herkunft),
      laden: richtung([wrVariante.bat_lade_kw],
        speicherFamilie.lade_leistung_kw, speicherFamilie.lade_herkunft),
    };
  }

  /*
   * Turmspannung einer Speichergröße = Modulanzahl × Modulnennspannung. Beides steht in
   * der Datenbasis mit eigener Quelle; fehlt eines, gibt es keine Spannung und damit
   * keine errechnete Grenze. Nie schätzen.
   *
   * Weist das Datenblatt die Spannung je Turmgröße selbst aus (AXITEC nennt
   * 192/288/384/480 V, Sungrow 128–512 V), steht sie als `spannung_v` an der Größe
   * und gilt — Herstellerangabe schlägt Rechnung, auch hier.
   */
  function turmSpannungV(speicherFamilie, groessenEintrag) {
    if (groessenEintrag && istZahl(groessenEintrag.spannung_v)) return groessenEintrag.spannung_v;
    if (!speicherFamilie || !speicherFamilie.modul || !istZahl(speicherFamilie.modul.spannung_v)) return null;
    /*
     * Parallel verschaltete Baureihen zaehlen NICHT mit: Dort bleibt die
     * Systemspannung bei jeder Groesse die Modulspannung, es waechst nur der Strom.
     * Multiplizieren hiesse hier, die Grenze um ein Vielfaches zu ueberschaetzen.
     *
     * Zwei Faelle fallen darunter. Erstens jedes Niedervolt-System: Die
     * BYD-Premium-LVS fuehrt ihr Datenblatt genau so — „Nominale Spannung 51,2 V"
     * steht einmal fuer die ganze Reihe von LVS 4.0 bis LVS 24.0. Zweitens
     * Hochvolt-Baureihen, die ausdruecklich parallel gestapelt werden (AlphaESS
     * 8.2P/10.1P: 256 V, „1–6 in Parallel"). Der zweite Fall kam bisher nur davon,
     * weil diese Groessen keine Modulzahl tragen — auf so einen Zufall darf sich
     * eine Rechnung nicht verlassen, deshalb `verschaltung` ausdruecklich.
     */
    if (speicherFamilie.verschaltung === 'parallel') return speicherFamilie.modul.spannung_v;
    if (spannungsklasse(speicherFamilie) === 'niedervolt') return speicherFamilie.modul.spannung_v;
    if (!groessenEintrag || !istZahl(groessenEintrag.module)) return null;
    return speicherFamilie.modul.spannung_v * groessenEintrag.module;
  }

  /*
   * Errechnete Paarungsgrenze: Der Wechselrichter begrenzt am Batterieeingang den Strom,
   * die Leistung ergibt sich erst mit der Turmspannung. Beide Zahlen stehen in
   * Hersteller-Datenblättern — die Multiplikation ist unsere, nicht die des Herstellers.
   * Genau diese Rechnung führt KOSTAL in seiner Fußnote selbst vor („UBat x 13 A").
   */
  function berechneteGrenzeKw(wrVariante, spannungV) {
    if (!wrVariante || !istZahl(wrVariante.bat_strom_a) || !istZahl(spannungV)) return null;
    return runde2(wrVariante.bat_strom_a * spannungV / 1000);
  }

  /*
   * Eignung gegen das Bedarfsprofil — nur behaupten, was belegbar ist:
   *  true  — belegte Entladeleistung >= Bedarf und Rechnung vollständig
   *  false — belegte Obergrenze < Bedarf (auch bei unvollständiger Rechnung korrekt:
   *          mehr als die Obergrenze kann die Kombi nicht)
   *  null  — Rechnung unvollständig und Obergrenze >= Bedarf ⇒ keine sichere Aussage
   */
  function eignung(entladen, bedarfKw) {
    if (entladen.kw === null) return null;
    if (entladen.kw < bedarfKw) return false;
    return entladen.unvollstaendig ? null : true;
  }

  // Kapazität einer Größe: dokumentierter Datenblattwert (nutzbar_kwh) hat Vorrang;
  // sonst Modulanzahl × Modulenergie (dokumentierte Herleitung) — sonst null.
  function kapazitaetKwh(speicherFamilie, groessenEintrag) {
    if (groessenEintrag && istZahl(groessenEintrag.nutzbar_kwh)) return groessenEintrag.nutzbar_kwh;
    if (speicherFamilie.modul && istZahl(speicherFamilie.modul.energie_kwh) && groessenEintrag && istZahl(groessenEintrag.module)) {
      return runde2(groessenEintrag.module * speicherFamilie.modul.energie_kwh);
    }
    return null;
  }

  /*
   * Preis-Index über der gepflegten Preisliste (daten/preise.js).
   * Schlüssel: 'speicher:<familie>:<groesse>' bzw. 'wr:<familie>:<varianten-id>'.
   * Kein Eintrag ⇒ null (UI: „Preis auf Anfrage") — nie 0, nie geschätzt.
   */
  function bauePreisIndex(preise) {
    var index = {};
    if (preise && Array.isArray(preise.eintraege)) {
      preise.eintraege.forEach(function (e) {
        if (!istZahl(e.preis_cents) || e.preis_cents <= 0) return; // kaputte Einträge nie übernehmen
        index[e.typ + ':' + e.familie + ':' + e.schluessel] = e;
      });
    }
    return index;
  }

  /*
   * Preisblock für eine Kombination. Nur belegbare Aussagen:
   *  - gesamt nur, wenn BEIDE Einzelpreise vorliegen
   *  - eur_pro_kwh_nutzbar = Gesamtpreis / dokumentierte nutzbare kWh — nur wenn beides da
   *  - Pflicht-Freischaltungen des WR (z. B. PLENTICORE G3: 3 × PLENTICOIN) werden in
   *    WR-Effektivpreis und Gesamtpreis EINGERECHNET — sonst hinkt der Vergleich.
   *    Fehlt der Freischaltungs-Preis, bleibt der Effektivpreis null (nie stillschweigend
   *    der zu niedrige Gerätepreis als Vergleichsbasis).
   */
  function kombiPreis(preisIndex, wrFamilie, wrVarianteId, speicherId, groesse, nutzbarKwh) {
    var sp = preisIndex['speicher:' + speicherId + ':' + groesse] || null;
    var wr = preisIndex['wr:' + wrFamilie.id + ':' + wrVarianteId] || null;

    // Variante nachschlagen: Leistungsstufen brauchen ihre eigenen Coin-Angaben.
    var variante = null;
    for (var vi = 0; vi < wrFamilie.varianten.length; vi++) {
      if (wrFamilie.varianten[vi].id === wrVarianteId) variante = wrFamilie.varianten[vi];
    }

    /*
     * Leistungsstufen sind kein eigenes Gerät: „PLENTICORE G3 M +Stufe 1" ist
     * dasselbe Basisgerät wie „G3 M", nur höher freigeschaltet. Der Shop führt
     * deshalb nur die Basisgeräte. Fehlt der Variantenpreis, rechnen wir
     * Basisgerät + Stufen-Coins — das ist der Preis, den der Kunde zahlt.
     */
    var ueberBasis = false;
    if (!wr && variante && variante.basis_variante) {
      var basis = preisIndex['wr:' + wrFamilie.id + ':' + variante.basis_variante] || null;
      if (basis) { wr = basis; ueberBasis = true; }
    }

    var zuschlagCents = null;
    var zuschlagText = null;
    var zuschlagQuelle = null;
    var zuschlagFehlt = false;
    var freischaltung = wrFamilie.batterie_freischaltung || null;
    var stufenCoins = (variante && istZahl(variante.freischaltung_stufen)) ? variante.freischaltung_stufen : 0;
    if (freischaltung || stufenCoins > 0) {
      var coinSchluessel = freischaltung ? freischaltung.preis_schluessel : null;
      var coin = coinSchluessel ? (preisIndex[coinSchluessel] || null) : null;
      var anzahl = (freischaltung ? freischaltung.anzahl_plenticoin : 0) + stufenCoins;
      var teile = [];
      if (freischaltung) teile.push(freischaltung.anzahl_plenticoin + ' × Batterie-Funktion');
      if (stufenCoins > 0) teile.push(stufenCoins + ' × Leistungsstufe');
      zuschlagText = 'Freischaltung erforderlich: ' + anzahl + ' × KOSTAL PLENTICOIN ('
        + teile.join(', ') + ')';
      zuschlagQuelle = freischaltung ? (freischaltung.quelle_hinweis || null) : null;
      if (coin) zuschlagCents = anzahl * coin.preis_cents;
      else zuschlagFehlt = true;
    }

    var wrEffektiv = null;
    if (wr) {
      if (!zuschlagText) wrEffektiv = wr.preis_cents;
      else if (zuschlagCents !== null) wrEffektiv = wr.preis_cents + zuschlagCents;
      // Freischaltung nötig, Coin-Preis unbekannt ⇒ wrEffektiv bleibt null,
      // damit nie der zu niedrige Gerätepreis als Vergleichsbasis durchgeht.
    }
    var gesamt = (sp && wrEffektiv !== null) ? sp.preis_cents + wrEffektiv : null;

    return {
      speicher_preis_cents: sp ? sp.preis_cents : null,
      speicher_verfuegbar: sp ? sp.verfuegbar : null,
      speicher_handle: sp ? sp.handle : null,
      speicher_variante_id: sp ? (sp.variante_id || null) : null,
      wr_preis_cents: wr ? wr.preis_cents : null,
      wr_verfuegbar: wr ? wr.verfuegbar : null,
      wr_handle: wr ? wr.handle : null,
      wr_shop_variante_id: wr ? (wr.variante_id || null) : null,
      // true ⇒ Preis stammt vom Basisgerät der Leistungsklasse, die Stufe kommt
      // über Coins dazu. Die UI muss das benennen, sonst wirkt der Preis falsch.
      wr_preis_ueber_basisgeraet: ueberBasis,
      wr_zuschlag_cents: zuschlagCents,
      wr_zuschlag_text: zuschlagText,
      wr_zuschlag_quelle: zuschlagQuelle,
      wr_zuschlag_fehlt: zuschlagFehlt,
      wr_preis_effektiv_cents: wrEffektiv,
      gesamt_preis_cents: gesamt,
      eur_pro_kwh_nutzbar: (gesamt !== null && istZahl(nutzbarKwh) && nutzbarKwh > 0)
        ? Math.round(gesamt / nutzbarKwh) / 100 : null, // €/kWh, 2 Nachkommastellen
      speicher_eur_pro_kwh: (sp && istZahl(nutzbarKwh) && nutzbarKwh > 0)
        ? Math.round(sp.preis_cents / nutzbarKwh) / 100 : null,
    };
  }

  // Preis-Formeln (Invariante 3) — Preise kommen aus der gepflegten Preisliste, nie aus Datenblättern.
  function eurProKwhNutzbar(preisEur, nutzbarKwh) {
    return Math.round((preisEur / nutzbarKwh) * 100) / 100;
  }

  function eurProKwhLebensdauer(preisEur, nutzbarKwh, garantieZyklen) {
    return Math.round((preisEur / (nutzbarKwh * garantieZyklen)) * 10000) / 10000;
  }

  /*
   * Hauptabfrage WR → Speicher: alle Speicher-Größen, je mit Status + Belegen +
   * Leistungsrechnung + Eignung. Ungeeignete und unbelegte werden NICHT entfernt.
   */
  function speicherFuerWr(daten, wrVarianteId, profilId, preise) {
    var wr = findeWrVariante(daten, wrVarianteId);
    if (!wr) return { fehler: 'wr_unbekannt' };
    var profil = PROFILE[profilId] ? profilId : 'standard';
    var bedarfKw = PROFILE[profil].kw;
    var preisIndex = bauePreisIndex(preise);

    var freigegeben = [];
    var aufAnfrage = [];

    daten.speicher.forEach(function (familie) {
      familie.groessen.forEach(function (g) {
        var belege = belegeFuerKombi(daten, wr.familie.id, wr.variante.id, familie.id, g.groesse);
        var s = statusFuerKombi(daten, belege,
          ausschlussFuerKombi(daten, wr.familie.id, wr.variante.id, familie.id, g.groesse));
        var spec = speicherSpec(familie, g);
        var leistung = kombiLeistung(wr.variante, spec, {
          dokumentiert: kombiGrenzeKw(belege, wr.variante.id, g.groesse),
          berechnet: berechneteGrenzeKw(wr.variante, turmSpannungV(familie, g)),
        });
        var kapazitaet = kapazitaetKwh(familie, g);
        var eintrag = {
          speicher_id: familie.id,
          hersteller: familie.hersteller,
          name: familie.name,
          groesse: g.groesse,
          // Volle Produktbezeichnung („LUNA2000-14-S1"), wenn die Datenbasis eine
          // pflegt — der Größen-Schlüssel allein („14") ist für Kunden nichtssagend.
          bezeichnung: g.bezeichnung || null,
          module: g.module,
          kapazitaet_kwh: kapazitaet,
          kapazitaet_dokumentiert: !!(g && istZahl(g.nutzbar_kwh)) && !familie.kapazitaet_herleitung,
          chemie: familie.modul ? familie.modul.chemie : null,
          spannungsklasse: spannungsklasse(familie),
          kapazitaet_herleitung: familie.kapazitaet_herleitung || null,
          // Einzelglieder der min()-Rechnung, damit die UI den Rechenweg zeigen kann
          speicher_entlade_kw: spec.entlade_leistung_kw,
          speicher_lade_kw: spec.lade_leistung_kw,
          leistung_herleitung: familie.leistung_herleitung || null,
          spec_quelle: familie.spec_quelle || null,
          status: s.status,
          belege: s.hersteller_belege,
          bestaetigungen: s.distributor_belege,
          /* Nur bei 'ausgeschlossen' gefüllt: Wortlaut und Quelle des Ausschlusses.
           * Ohne beides darf die UI ihn nicht behaupten. */
          ausschluss_wortlaut: s.ausschluss_wortlaut || null,
          ausschluss_quelle: s.ausschluss_quelle || null,
          einschraenkungen: belege.map(function (b) { return b.einschraenkung; }).filter(Boolean),
          kombi: leistung,
          geeignet: eignung(leistung.entladen, bedarfKw),
          garantie_jahre: istZahl(familie.garantie_jahre) ? familie.garantie_jahre : null,
          garantie_zyklen: istZahl(familie.garantie_zyklen) ? familie.garantie_zyklen : null,
          preis: kombiPreis(preisIndex, wr.familie, wr.variante.id, familie.id, g.groesse, kapazitaet),
        };
        if (s.status === 'freigegeben') freigegeben.push(eintrag);
        else aufAnfrage.push(eintrag);
      });
    });

    return {
      wr: { familie_id: wr.familie.id, variante_id: wr.variante.id, name: wr.variante.name, hersteller: wr.familie.hersteller, spannungsklasse: spannungsklasse(wr.familie), ac_kw: wr.variante.ac_kw, bat_lade_kw: wr.variante.bat_lade_kw, bat_entlade_kw: wr.variante.bat_entlade_kw, spec_quelle: wr.familie.spec_quelle, spec_hinweis: wr.familie.spec_hinweis },
      profil: profil,
      bedarf_kw: bedarfKw,
      freigegeben: sortiereErgebnis(freigegeben),
      auf_anfrage: aufAnfrage,
      stand: daten.stand,
    };
  }

  /*
   * Hauptabfrage Speicher → WR (umgekehrte Richtung, gleiche Whitelist).
   */
  /*
   * Geräte, die eine Freigabequelle dieses Speichers ausdrücklich nennt, die
   * wir aber nicht führen — weil uns das Datenblatt fehlt.
   *
   * Das ist KEIN Kompatibilitätsergebnis und geht in keine Rechnung ein: Ohne
   * Datenblatt gibt es keine Leistungswerte, und geschätzt wird nichts
   * (Invariante 1 und 3). Es ist die ehrliche Auskunft, dass die Liste des
   * Herstellers länger ist als unsere — ohne sie wäre unsere Ergebnisliste
   * still um eine Zeile kürzer, und niemand könnte das bemerken.
   *
   * Gepflegt wird das an der Quelle als `nennt_geraete` mit `variante: null`
   * (Gerät fehlt, Familie gibt es) bzw. `familie: null` (ganze Baureihe fehlt).
   *
   * Gezeigt wird nur, was `gilt_fuer` ausdrücklich diesem Speicher zuordnet.
   * Die Zuordnung wird NICHT hergeleitet: Dass ein Dokument irgendwo ein Gerät
   * nennt und irgendwo eine Freigabe für diesen Speicher trägt, heißt nicht,
   * dass der Hersteller genau diese Paarung freigegeben hat. Die KOSTAL-Liste
   * etwa führt eine ganze Gerätespalte, deren Zeilen je eigene Batterien
   * betreffen — daraus „freigegeben" zu lesen wäre der Schluss, den
   * Invariante 1 verbietet. Ohne `gilt_fuer` bleibt ein Eintrag also
   * Arbeitsliste in listen-abgleich.js und erscheint dem Kunden nicht.
   */
  function offeneGeraeteFuerSpeicher(daten, speicherId) {
    var offen = [];
    Object.keys(daten.quellen).forEach(function (schluessel) {
      var q = daten.quellen[schluessel];
      if (!q || !q.nennt_geraete) return;
      q.nennt_geraete.forEach(function (g) {
        var fehlt = !g.familie
          || (Object.prototype.hasOwnProperty.call(g, 'variante') && g.variante === null);
        if (!fehlt) return;
        if (!Array.isArray(g.gilt_fuer) || g.gilt_fuer.indexOf(speicherId) === -1) return;
        offen.push({ name: g.name, grund: g.grund || null, quelle: schluessel });
      });
    });
    return offen;
  }

  function wrFuerSpeicher(daten, speicherId, groesse, profilId, preise) {
    var familie = findeSpeicher(daten, speicherId);
    if (!familie) return { fehler: 'speicher_unbekannt' };
    var profil = PROFILE[profilId] ? profilId : 'standard';
    var bedarfKw = PROFILE[profil].kw;
    var preisIndex = bauePreisIndex(preise);

    var groessenEintrag = null;
    for (var i = 0; i < familie.groessen.length; i++) {
      if (familie.groessen[i].groesse === groesse) groessenEintrag = familie.groessen[i];
    }
    var kapazitaet = groessenEintrag ? kapazitaetKwh(familie, groessenEintrag) : null;

    var freigegeben = [];
    var aufAnfrage = [];

    daten.wechselrichter.forEach(function (wrFamilie) {
      wrFamilie.varianten.forEach(function (variante) {
        var belege = belegeFuerKombi(daten, wrFamilie.id, variante.id, speicherId, groesse);
        var s = statusFuerKombi(daten, belege,
          ausschlussFuerKombi(daten, wrFamilie.id, variante.id, speicherId, groesse));
        var leistung = kombiLeistung(variante, speicherSpec(familie, groessenEintrag), {
          dokumentiert: kombiGrenzeKw(belege, variante.id, groesse),
          berechnet: berechneteGrenzeKw(variante, turmSpannungV(familie, groessenEintrag)),
        });
        var eintrag = {
          wr_familie_id: wrFamilie.id,
          wr_familie_name: wrFamilie.name,
          spannungsklasse: spannungsklasse(wrFamilie),
          wr_variante_id: variante.id,
          hersteller: wrFamilie.hersteller,
          name: variante.name,
          ac_kw: variante.ac_kw,
          // Einzelglieder der min()-Rechnung, damit die UI den Rechenweg zeigen kann
          bat_lade_kw: istZahl(variante.bat_lade_kw) ? variante.bat_lade_kw : null,
          bat_entlade_kw: istZahl(variante.bat_entlade_kw) ? variante.bat_entlade_kw : null,
          speicher_entlade_kw: speicherSpec(familie, groessenEintrag).entlade_leistung_kw,
          speicher_lade_kw: speicherSpec(familie, groessenEintrag).lade_leistung_kw,
          kapazitaet_dokumentiert: !!(groessenEintrag && istZahl(groessenEintrag.nutzbar_kwh)),
          spec_quelle: wrFamilie.spec_quelle || null,
          spec_hinweis: wrFamilie.spec_hinweis || null,
          status: s.status,
          belege: s.hersteller_belege,
          bestaetigungen: s.distributor_belege,
          /* Nur bei 'ausgeschlossen' gefüllt: Wortlaut und Quelle des Ausschlusses.
           * Ohne beides darf die UI ihn nicht behaupten. */
          ausschluss_wortlaut: s.ausschluss_wortlaut || null,
          ausschluss_quelle: s.ausschluss_quelle || null,
          einschraenkungen: belege.map(function (b) { return b.einschraenkung; }).filter(Boolean),
          kombi: leistung,
          geeignet: eignung(leistung.entladen, bedarfKw),
          preis: kombiPreis(preisIndex, wrFamilie, variante.id, speicherId, groesse, kapazitaet),
        };
        if (s.status === 'freigegeben') freigegeben.push(eintrag);
        else aufAnfrage.push(eintrag);
      });
    });

    return {
      speicher: {
        id: familie.id, hersteller: familie.hersteller, name: familie.name, groesse: groesse,
        kapazitaet_kwh: groessenEintrag ? kapazitaetKwh(familie, groessenEintrag) : null,
        chemie: familie.modul ? familie.modul.chemie : null,
        spannungsklasse: spannungsklasse(familie),
        garantie_jahre: istZahl(familie.garantie_jahre) ? familie.garantie_jahre : null,
        garantie_zyklen: istZahl(familie.garantie_zyklen) ? familie.garantie_zyklen : null,
      },
      profil: profil,
      bedarf_kw: bedarfKw,
      freigegeben: sortiereErgebnis(freigegeben),
      auf_anfrage: aufAnfrage,
      stand: daten.stand,
    };
  }

  /*
   * ---- Ausbaustufen (Use Case 2: „Speicher vorhanden — geht mehr?") ----------
   *
   * Beantwortet AUSSCHLIESSLICH die Whitelist-Frage: Welche größeren Größen
   * derselben Speicher-Familie sind mit dem vorhandenen Wechselrichter
   * herstellerfreigegeben? Das ist eine Aussage über die FREIGABE der größeren
   * Konfiguration — ausdrücklich KEINE Aussage darüber, ob ein bereits
   * installierter Turm technisch nachrüstbar ist (Modulmischung, SOH-Angleichung,
   * Firmware). Dazu liegt kein Herstellerdokument vor; solche Hinweise trägt die
   * UI getrennt als redaktionellen inselvolt-Hinweis, nie als Freigabe.
   *
   * „Größer" = mehr Module, wenn beide Modulanzahlen bekannt sind, sonst mehr
   * nutzbare kWh. Ist beides unbekannt, bleibt die Größe außen vor statt geraten
   * zu werden.
   */
  function istGroesser(kandidat, ist) {
    if (istZahl(kandidat.module) && istZahl(ist.module)) return kandidat.module > ist.module;
    if (istZahl(kandidat.kapazitaet_kwh) && istZahl(ist.kapazitaet_kwh)) {
      return kandidat.kapazitaet_kwh > ist.kapazitaet_kwh;
    }
    /*
     * Dritter Weg für Baureihen ohne Datenblatt (z. B. AXITEC AXIstorage Li SV2:
     * die Herstellerliste nennt 6.7 / 10.1 / 13.5 / 16.9, aber weder Modulanzahl
     * noch nutzbare kWh). Verglichen wird dann die BEZEICHNUNG der Größe, wie
     * der Hersteller sie führt — das ordnet die Stufen, ohne einen Wert zu
     * erfinden. Die Kapazität bleibt weiterhin unbekannt und wird als solche
     * ausgewiesen; nur die Reihenfolge „größer/kleiner" steht damit fest.
     */
    var a = parseFloat(String(kandidat.groesse).replace(',', '.'));
    var b = parseFloat(String(ist.groesse).replace(',', '.'));
    if (istZahl(a) && istZahl(b) && /^[\d.,]+$/.test(String(kandidat.groesse)) && /^[\d.,]+$/.test(String(ist.groesse))) {
      return a > b;
    }
    return false;
  }

  function erweiterungFuerSpeicher(daten, speicherId, aktuelleGroesse, wrVarianteId, preise) {
    var familie = findeSpeicher(daten, speicherId);
    if (!familie) return { fehler: 'speicher_unbekannt' };
    var wr = wrVarianteId ? findeWrVariante(daten, wrVarianteId) : null;
    if (wrVarianteId && !wr) return { fehler: 'wr_unbekannt' };
    var preisIndex = bauePreisIndex(preise);

    var istEintrag = null;
    for (var i = 0; i < familie.groessen.length; i++) {
      if (familie.groessen[i].groesse === aktuelleGroesse) istEintrag = familie.groessen[i];
    }
    if (!istEintrag) return { fehler: 'groesse_unbekannt' };

    function baueStufe(g) {
      var kapazitaet = kapazitaetKwh(familie, g);
      var spec = speicherSpec(familie, g);
      var belege = wr ? belegeFuerKombi(daten, wr.familie.id, wr.variante.id, familie.id, g.groesse) : [];
      var s = wr
        ? statusFuerKombi(daten, belege,
          ausschlussFuerKombi(daten, wr.familie.id, wr.variante.id, familie.id, g.groesse))
        : { status: 'wr_unbekannt', hersteller_belege: [], distributor_belege: [] };
      return {
        groesse: g.groesse,
        bezeichnung: g.bezeichnung || null,
        module: istZahl(g.module) ? g.module : null,
        kapazitaet_kwh: kapazitaet,
        kapazitaet_dokumentiert: istZahl(g.nutzbar_kwh),
        speicher_entlade_kw: spec.entlade_leistung_kw,
        speicher_lade_kw: spec.lade_leistung_kw,
        status: s.status,
        belege: s.hersteller_belege,
        bestaetigungen: s.distributor_belege,
        ausschluss_wortlaut: s.ausschluss_wortlaut || null,
        ausschluss_quelle: s.ausschluss_quelle || null,
        einschraenkungen: belege.map(function (b) { return b.einschraenkung; }).filter(Boolean),
        kombi: wr ? kombiLeistung(wr.variante, spec, {
          dokumentiert: kombiGrenzeKw(belege, wr.variante.id, g.groesse),
          berechnet: berechneteGrenzeKw(wr.variante, turmSpannungV(familie, g)),
        }) : null,
        preis: wr
          ? kombiPreis(preisIndex, wr.familie, wr.variante.id, familie.id, g.groesse, kapazitaet)
          : null,
        speicher_preis_cents: (preisIndex['speicher:' + familie.id + ':' + g.groesse] || {}).preis_cents || null,
        speicher_verfuegbar: (preisIndex['speicher:' + familie.id + ':' + g.groesse] || {}).verfuegbar,
        speicher_handle: (preisIndex['speicher:' + familie.id + ':' + g.groesse] || {}).handle || null,
        speicher_variante_id: (preisIndex['speicher:' + familie.id + ':' + g.groesse] || {}).variante_id || null,
      };
    }

    /*
     * Das Erweiterungsmodul der Familie („Nur Speichermodul" im Shop): Wer
     * erweitert, kauft Module, keinen zweiten Komplettspeicher. Ohne Zuordnung
     * bleibt alles null und die UI fällt auf die Komplettspeicher-Differenz
     * mit Erklärung zurück.
     */
    var modul = preisIndex['modul:' + familie.id + ':modul'] || null;

    var ist = baueStufe(istEintrag);

    var stufen = familie.groessen
      .map(baueStufe)
      .filter(function (k) { return istGroesser(k, ist); })
      .map(function (k) {
        /*
         * Zugewinn ehrlich rechnen: Differenzen nur, wenn BEIDE Seiten belegt
         * sind. Der Preis-Delta ist der Unterschied zweier KOMPLETTSPEICHER-
         * Preise, nicht der Preis einer Nachrüstung — die UI muss das benennen.
         */
        k.delta_kwh = (istZahl(k.kapazitaet_kwh) && istZahl(ist.kapazitaet_kwh))
          ? runde2(k.kapazitaet_kwh - ist.kapazitaet_kwh) : null;
        k.delta_module = (istZahl(k.module) && istZahl(ist.module)) ? k.module - ist.module : null;
        /*
         * Leistungs-Zugewinn nur aus VOLLSTÄNDIGEN Rechnungen. Ist ein Glied
         * unbekannt, sind beide Werte bloße Obergrenzen — deren Differenz wäre
         * keine Aussage, und „±0 kW" läse sich als „bringt nachweislich nichts".
         */
        var neuE = k.kombi ? k.kombi.entladen : null;
        var altE = ist.kombi ? ist.kombi.entladen : null;
        var vollstaendig = !!(neuE && altE && !neuE.unvollstaendig && !altE.unvollstaendig);
        k.delta_entlade_kw = (vollstaendig && istZahl(neuE.kw) && istZahl(altE.kw))
          ? runde2(neuE.kw - altE.kw) : null;
        k.delta_preis_cents = (istZahl(k.speicher_preis_cents) && istZahl(ist.speicher_preis_cents))
          ? k.speicher_preis_cents - ist.speicher_preis_cents : null;
        /*
         * Nachrüstpreis = Zusatzmodule × Modulpreis. Das ist der Betrag, um den
         * es beim Erweitern wirklich geht — die Komplettspeicher-Differenz
         * bleibt als Rückfall, wenn kein Modulpreis zugeordnet ist.
         */
        k.modul_preis_cents = modul ? modul.preis_cents : null;
        k.modul_handle = modul ? modul.handle : null;
        k.modul_variante_id = modul ? modul.variante_id : null;
        k.modul_verfuegbar = modul ? modul.verfuegbar : null;
        k.nachruest_preis_cents = (modul && istZahl(k.delta_module) && k.delta_module > 0)
          ? k.delta_module * modul.preis_cents : null;
        // Bringt die größere Batterie überhaupt mehr Leistung, oder deckelt der WR?
        k.leistung_gedeckelt_durch_wr = !!(k.kombi && k.kombi.entladen
          && k.kombi.entladen.begrenzt_durch === 'wr' && k.delta_entlade_kw === 0);
        return k;
      })
      .sort(function (a, b) {
        var ka = istZahl(a.kapazitaet_kwh) ? a.kapazitaet_kwh : null;
        var kb = istZahl(b.kapazitaet_kwh) ? b.kapazitaet_kwh : null;
        if (ka !== null && kb !== null && ka !== kb) return ka - kb;
        // ohne Kapazität nach der Größen-Bezeichnung des Herstellers ordnen
        return String(a.groesse).localeCompare(String(b.groesse), 'de', { numeric: true });
      });

    var freigegebene = stufen.filter(function (s) { return s.status === 'freigegeben'; });

    return {
      speicher: {
        id: familie.id, hersteller: familie.hersteller, name: familie.name,
        garantie_jahre: istZahl(familie.garantie_jahre) ? familie.garantie_jahre : null,
        garantie_zyklen: istZahl(familie.garantie_zyklen) ? familie.garantie_zyklen : null,
      },
      wr: wr ? {
        familie_id: wr.familie.id, variante_id: wr.variante.id, name: wr.variante.name,
        hersteller: wr.familie.hersteller, ac_kw: wr.variante.ac_kw,
      } : null,
      ist: ist,
      stufen: stufen,
      anzahl_freigegeben: freigegebene.length,
      groesste_freigegebene: freigegebene.length ? freigegebene[freigegebene.length - 1] : null,
      // true ⇒ ehrliche Beratungsaussage „mehr Kapazität, aber nicht mehr Leistung"
      wr_deckelt_leistung: !!(ist.kombi && ist.kombi.entladen && ist.kombi.entladen.begrenzt_durch === 'wr'),
      stand: daten.stand,
    };
  }

  /*
   * ---- Filter & Sortierung (rein, damit die UI nichts nachrechnet) ----------
   *
   * Regel für jedes Kriterium: Ein Eintrag mit UNBEKANNTEM Wert wird nie
   * weggefiltert (sonst verschwinden ehrliche Lücken lautlos aus dem Ergebnis) —
   * er wird in der UI als „Wert offen" gekennzeichnet.
   */
  function filtereErgebnis(eintraege, filter) {
    var f = filter || {};
    return eintraege.filter(function (e) {
      if (f.hersteller && f.hersteller.length && f.hersteller.indexOf(e.hersteller) === -1) return false;
      if (istZahl(f.min_entlade_kw)) {
        var kw = e.kombi && e.kombi.entladen ? e.kombi.entladen.kw : null;
        if (istZahl(kw) && kw < f.min_entlade_kw) return false; // unbekannt bleibt drin
      }
      if (istZahl(f.min_kapazitaet_kwh) && istZahl(e.kapazitaet_kwh) && e.kapazitaet_kwh < f.min_kapazitaet_kwh) return false;
      if (istZahl(f.max_kapazitaet_kwh) && istZahl(e.kapazitaet_kwh) && e.kapazitaet_kwh > f.max_kapazitaet_kwh) return false;
      if (istZahl(f.max_eur_pro_kwh)) {
        var ek = e.preis ? e.preis.speicher_eur_pro_kwh : null;
        if (istZahl(ek) && ek > f.max_eur_pro_kwh) return false;
      }
      if (f.spannungsklasse && e.spannungsklasse && e.spannungsklasse !== f.spannungsklasse) return false;
      if (istZahl(f.min_garantie_jahre) && istZahl(e.garantie_jahre) && e.garantie_jahre < f.min_garantie_jahre) return false;
      if (f.nur_verfuegbar && e.preis) {
        // Gefiltert wird immer auf das Gerät, das der Kunde in dieser Richtung sucht.
        var v = f.modus === 'wr' ? e.preis.wr_verfuegbar : e.preis.speicher_verfuegbar;
        if (v === false) return false;
      }
      return true;
    });
  }

  /*
   * Sortierungen. Unbekannte Werte landen IMMER am Ende — nie vorn, weil ein
   * fehlender Preis sonst als „günstigster" durchginge.
   */
  var SORTIERUNGEN = {
    empfehlung: null, // Reihenfolge aus sortiereErgebnis (Eignung ▸ Leistung ▸ Kapazität)
    preis_auf: function (e) { return e.preis ? e.preis.speicher_preis_cents : null; },
    preis_ab: function (e) { return e.preis ? e.preis.speicher_preis_cents : null; },
    eur_kwh_auf: function (e) { return e.preis ? e.preis.speicher_eur_pro_kwh : null; },
    kapazitaet_auf: function (e) { return e.kapazitaet_kwh; },
    kapazitaet_ab: function (e) { return e.kapazitaet_kwh; },
    entladen_ab: function (e) { return e.kombi && e.kombi.entladen ? e.kombi.entladen.kw : null; },
    laden_ab: function (e) { return e.kombi && e.kombi.laden ? e.kombi.laden.kw : null; },
    garantie_ab: function (e) { return e.garantie_jahre; },
    // Richtung Speicher → Wechselrichter: gesucht wird der WR, also zählt sein Preis.
    wr_preis_auf: function (e) { return e.preis ? e.preis.wr_preis_effektiv_cents : null; },
    wr_preis_ab: function (e) { return e.preis ? e.preis.wr_preis_effektiv_cents : null; },
    system_eur_kwh_auf: function (e) { return e.preis ? e.preis.eur_pro_kwh_nutzbar : null; },
    system_eur_kwh_ab: function (e) { return e.preis ? e.preis.eur_pro_kwh_nutzbar : null; },
    gesamt_auf: function (e) { return e.preis ? e.preis.gesamt_preis_cents : null; },
    gesamt_ab: function (e) { return e.preis ? e.preis.gesamt_preis_cents : null; },
    ac_ab: function (e) { return e.ac_kw; },
    ac_auf: function (e) { return e.ac_kw; },
    // Gegenrichtungen, damit jede Spalte in beide Richtungen sortierbar ist
    eur_kwh_ab: function (e) { return e.preis ? e.preis.speicher_eur_pro_kwh : null; },
    entladen_auf: function (e) { return e.kombi && e.kombi.entladen ? e.kombi.entladen.kw : null; },
    laden_auf: function (e) { return e.kombi && e.kombi.laden ? e.kombi.laden.kw : null; },
    garantie_auf: function (e) { return e.garantie_jahre; },
    verfuegbar_ab: function (e) {
      if (!e.preis) return null;
      var v = e.preis.speicher_verfuegbar;
      if (v === null || v === undefined) v = e.preis.wr_verfuegbar;
      return v === true ? 1 : (v === false ? 0 : null);
    },
    verfuegbar_auf: function (e) { return SORTIERUNGEN.verfuegbar_ab(e); },
  };
  var ABSTEIGEND = {
    preis_ab: 1, kapazitaet_ab: 1, entladen_ab: 1, laden_ab: 1, garantie_ab: 1, ac_ab: 1,
    wr_preis_ab: 1, system_eur_kwh_ab: 1, gesamt_ab: 1, eur_kwh_ab: 1, verfuegbar_ab: 1,
  };

  function sortiereNach(eintraege, schluessel) {
    var wert = SORTIERUNGEN[schluessel];
    if (!wert) return eintraege.slice();
    var ab = !!ABSTEIGEND[schluessel];
    return eintraege.slice().sort(function (a, b) {
      var wa = wert(a);
      var wb = wert(b);
      var fa = istZahl(wa);
      var fb = istZahl(wb);
      if (!fa && !fb) return String(a.name).localeCompare(String(b.name), 'de');
      if (!fa) return 1;   // unbekannt immer ans Ende, in beiden Richtungen
      if (!fb) return -1;
      if (wa !== wb) return ab ? wb - wa : wa - wb;
      return String(a.name).localeCompare(String(b.name), 'de');
    });
  }

  /*
   * Ranking innerhalb der freigegebenen Kombis (Transparenz, keine Marge-Logik):
   *  1. geeignet true > null (unbewertbar) > false — Ungeeignete ans Ende, nie entfernt.
   *  2. innerhalb: belegte Entladeleistung absteigend (beste Lade-/Entladeleistung zuerst),
   *  3. Tiebreaker: Kapazität aufsteigend, dann Name (Determinismus).
   */
  function sortiereErgebnis(eintraege) {
    var rang = { 'true': 0, 'null': 1, 'false': 2 };
    return eintraege.slice().sort(function (a, b) {
      var ra = rang[String(a.geeignet)];
      var rb = rang[String(b.geeignet)];
      if (ra !== rb) return ra - rb;
      var ea = a.kombi.entladen.kw === null ? -1 : a.kombi.entladen.kw;
      var eb = b.kombi.entladen.kw === null ? -1 : b.kombi.entladen.kw;
      if (ea !== eb) return eb - ea;
      var ka = a.kapazitaet_kwh === null || a.kapazitaet_kwh === undefined ? Infinity : a.kapazitaet_kwh;
      var kb = b.kapazitaet_kwh === null || b.kapazitaet_kwh === undefined ? Infinity : b.kapazitaet_kwh;
      if (ka !== kb) return ka - kb;
      return String(a.name).localeCompare(String(b.name), 'de');
    });
  }

  /*
   * ---------------------------------------------------- Geräteauswahl ------
   *
   * Flache Liste aller wählbaren Gegenstücke für das Suchfeld im Overlay.
   * Zusammengesetzt aus Hersteller, Baureihe und Gerät, damit eine einzige
   * Eingabe („symo 10") trifft, egal woran der Kunde sich erinnert.
   */
  function geraeteliste(daten, typ) {
    var liste = [];
    if (typ === 'wr') {
      daten.wechselrichter.forEach(function (f) {
        f.varianten.forEach(function (v) {
          liste.push({
            wert: v.id,
            hersteller: f.hersteller,
            baureihe: f.name,
            name: v.name,
            zusatz: istZahl(v.ac_kw) ? v.ac_kw + ' kW' : null,
            spannungsklasse: spannungsklasse(f),
            suche: (f.hersteller + ' ' + f.name + ' ' + v.name).toLowerCase(),
          });
        });
      });
    } else {
      daten.speicher.forEach(function (f) {
        f.groessen.forEach(function (g) {
          var kwh = kapazitaetKwh(f, g);
          liste.push({
            wert: f.id + '~' + g.groesse,
            hersteller: f.hersteller,
            baureihe: f.name,
            name: g.bezeichnung || g.groesse,
            zusatz: istZahl(kwh) ? String(kwh).replace('.', ',') + ' kWh' : null,
            spannungsklasse: spannungsklasse(f),
            suche: (f.hersteller + ' ' + f.name + ' ' + (g.bezeichnung || g.groesse)).toLowerCase(),
          });
        });
      });
    }
    return liste.sort(function (a, b) {
      if (a.hersteller !== b.hersteller) return a.hersteller.localeCompare(b.hersteller, 'de');
      if (a.baureihe !== b.baureihe) return a.baureihe.localeCompare(b.baureihe, 'de');
      return String(a.name).localeCompare(String(b.name), 'de', { numeric: true });
    });
  }

  /* Suchtreffer für das Eingabefeld. Jedes Wort der Eingabe muss vorkommen —
   * damit trennt „fronius 10" zuverlässig, ohne dass die Reihenfolge zählt. */
  function suche(liste, text, grenze) {
    var worte = String(text || '').toLowerCase().split(/\s+/).filter(Boolean);
    if (!worte.length) return liste.slice(0, grenze || 12);
    var treffer = liste.filter(function (e) {
      return worte.every(function (w) { return e.suche.indexOf(w) !== -1; });
    });
    return grenze ? treffer.slice(0, grenze) : treffer;
  }


  return {
    PROFILE: PROFILE,
    WESENTLICHE_HERSTELLER: WESENTLICHE_HERSTELLER,
    herstellerRang: herstellerRang,
    vergleicheHersteller: vergleicheHersteller,
    SORTIERUNGEN: SORTIERUNGEN,
    spannungsklasse: spannungsklasse,
    speicherFuerWr: speicherFuerWr,
    wrFuerSpeicher: wrFuerSpeicher,
    offeneGeraeteFuerSpeicher: offeneGeraeteFuerSpeicher,
    erweiterungFuerSpeicher: erweiterungFuerSpeicher,
    filtereErgebnis: filtereErgebnis,
    sortiereNach: sortiereNach,
    belegeFuerKombi: belegeFuerKombi,
    kombiGrenzeKw: kombiGrenzeKw,
    turmSpannungV: turmSpannungV,
    speicherGrenzeKw: speicherGrenzeKw,
    berechneteGrenzeKw: berechneteGrenzeKw,
    statusFuerKombi: statusFuerKombi,
    ausschlussFuerKombi: ausschlussFuerKombi,
    kombiLeistung: kombiLeistung,
    speicherSpec: speicherSpec,
    eignung: eignung,
    kapazitaetKwh: kapazitaetKwh,
    bauePreisIndex: bauePreisIndex,
    kombiPreis: kombiPreis,
    eurProKwhNutzbar: eurProKwhNutzbar,
    eurProKwhLebensdauer: eurProKwhLebensdauer,
    geraeteliste: geraeteliste,
    suche: suche,
  };
});
